import { LabelValueObject, Country } from '../../../../Types/IAnalyticsSnapshotReportType';

// This function is used to get the updated country selection based on the selected region
// This function is used in the NCF dashboard filters to get the updated country selection based on the selected region
export const getUpdatedCountrySelection = (
  regions: string[], //regions selected in the filter
  countrySelected: string[], // countries already selected in the filter
  regionCountryMapping: Record<string, Country[]>, //mapping of region to countries
) => {
  const updatedcountryOptions = regions
    .map((region) => {
      return regionCountryMapping[region]?.map((el: Country) => {
        return {
          label: el.COUNTRY_NAME,
          value: el.COUNTRY_CODE,
        };
      });
    })
    .flatMap((el) => el)
    .filter((el) => el !== undefined); //need this as Australia has no country, so it returns undefined
  // Check if country is present in the selected region
  let updatedFilteredCountries = [] as string[];
  if (countrySelected.length > 0) {
    updatedFilteredCountries = countrySelected.filter((country) => {
      return updatedcountryOptions.some((el: LabelValueObject) => el.value === country);
    });
  }
  return { updatedcountryOptions, updatedFilteredCountries };
};
